// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.loginBtn {
  display: flex;
  align-items: center;
  width: 100%;
  background-color: #ffd278;
  height: 3rem;
  border-top-right-radius: 37px;
  border-bottom-right-radius: 37px;
  display: flex;
}

.btn-login {
  text-decoration: none;
  text-align: left;
  font-family: "Lato", sans-serif !important;
  font-weight: 600;
  font-size: 12px;
  letter-spacing: 0px;
  color: #1a1919;
  opacity: 1;
}

.other-yellow-navbar {
  display: flex !important;
  flex-direction: row;
  flex-wrap: nowrap !important;
  align-items: center;
  position: relative;
}

.non-yellow-navbar {
  display: flex !important;
  flex-direction: row;
  flex-wrap: nowrap !important;
  align-items: center;
  position: relative;
}

.novisible {
  display: none !important;
}

.btn-body {
  background: #1a1919 0% 0% no-repeat padding-box;
  border-radius: 9px;
  opacity: 1;
  color: white;
  height: 2rem;
  width: 2rem;
  cursor: pointer;
  border: none;
  display: flex;
  justify-content: center;
  align-items: center;
}
.btn-body label {
  cursor: pointer;
  margin: 0;
}

.btn-switch-lenguage {
  padding: 0px !important;
}
.btn-switch-lenguage label {
  font-family: "Lato", sans-serif !important;
}

.morePadding {
  margin-left: 1rem;
  top: -0.6rem;
  right: -2rem;
}

.navbar-label-rest {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding-right: 4rem;
  flex-direction: row;
  cursor: pointer;
  width: 100%;
  margin-left: 20px;
}

.navbar-label-rest-nolocation {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: row;
  cursor: pointer;
  width: 20%;
  margin-left: 10px;
}

`, "",{"version":3,"sources":["webpack://./src/sass/layout/loginBtn/loginBtn.scss","webpack://./src/sass/layout/loginBtn/loginBtn.css","webpack://./src/sass/utilities/_variables.scss"],"names":[],"mappings":"AAGA;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,yBAAA;EACA,YAAA;EACA,6BAAA;EACA,gCAAA;EACA,aAAA;ACFF;;ADIA;EACE,qBAAA;EACA,gBAAA;EACA,0CEdK;EFeL,gBAAA;EACA,eAAA;EACA,mBAAA;EACA,cAAA;EACA,UAAA;ACDF;;ADGA;EACE,wBAAA;EACA,mBAAA;EACA,4BAAA;EACA,mBAAA;EACA,kBAAA;ACAF;;ADEA;EACE,wBAAA;EACA,mBAAA;EACA,4BAAA;EACA,mBAAA;EACA,kBAAA;ACCF;;ADCA;EACE,wBAAA;ACEF;;ADCA;EACE,+CAAA;EACA,kBAAA;EACA,UAAA;EACA,YAAA;EACA,YAAA;EACA,WAAA;EACA,eAAA;EACA,YAAA;EAEA,aAAA;EACA,uBAAA;EACA,mBAAA;ACCF;ADAE;EACE,eAAA;EACA,SAAA;ACEJ;;ADCA;EACE,uBAAA;ACEF;ADAE;EACE,0CE7DG;AD+DP;;ADEA;EACE,iBAAA;EACA,YAAA;EACA,YAAA;ACCF;;ADCA;EACE,aAAA;EACA,yBAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;EACA,eAAA;EACA,WAAA;EACA,iBAAA;ACEF;;ADCA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBAAA;EACA,eAAA;EACA,UAAA;EACA,iBAAA;ACEF","sourcesContent":["@import \"../../utilities/mixins\";\n@import \"../../utilities/variables\";\n\n.loginBtn {\n  display: flex;\n  align-items: center;\n  width: 100%;\n  background-color: #ffd278;\n  height: 3rem;\n  border-top-right-radius: 37px;\n  border-bottom-right-radius: 37px;\n  display: flex;\n}\n.btn-login {\n  text-decoration: none;\n  text-align: left;\n  font-family: $Font;\n  font-weight: 600;\n  font-size: 12px;\n  letter-spacing: 0px;\n  color: #1a1919;\n  opacity: 1;\n}\n.other-yellow-navbar {\n  display: flex !important;\n  flex-direction: row;\n  flex-wrap: nowrap !important;\n  align-items: center;\n  position: relative;\n}\n.non-yellow-navbar {\n  display: flex !important;\n  flex-direction: row;\n  flex-wrap: nowrap !important;\n  align-items: center;\n  position: relative;\n}\n.novisible {\n  display: none !important;\n}\n\n.btn-body {\n  background: #1a1919 0% 0% no-repeat padding-box;\n  border-radius: 9px;\n  opacity: 1;\n  color: white;\n  height: 2rem;\n  width: 2rem;\n  cursor: pointer;\n  border: none;\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  label {\n    cursor: pointer;\n    margin: 0;\n  }\n}\n.btn-switch-lenguage {\n  padding: 0px !important;\n\n  label {\n    font-family: $Font;\n  }\n}\n\n.morePadding {\n  margin-left: 1rem;\n  top: -0.6rem;\n  right: -2rem;\n}\n.navbar-label-rest {\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  padding-right: 4rem;\n  flex-direction: row;\n  cursor: pointer;\n  width: 100%;\n  margin-left: 20px;\n}\n\n.navbar-label-rest-nolocation {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: row;\n  cursor: pointer;\n  width: 20%;\n  margin-left: 10px;\n}\n",".loginBtn {\n  display: flex;\n  align-items: center;\n  width: 100%;\n  background-color: #ffd278;\n  height: 3rem;\n  border-top-right-radius: 37px;\n  border-bottom-right-radius: 37px;\n  display: flex;\n}\n\n.btn-login {\n  text-decoration: none;\n  text-align: left;\n  font-family: \"Lato\", sans-serif !important;\n  font-weight: 600;\n  font-size: 12px;\n  letter-spacing: 0px;\n  color: #1a1919;\n  opacity: 1;\n}\n\n.other-yellow-navbar {\n  display: flex !important;\n  flex-direction: row;\n  flex-wrap: nowrap !important;\n  align-items: center;\n  position: relative;\n}\n\n.non-yellow-navbar {\n  display: flex !important;\n  flex-direction: row;\n  flex-wrap: nowrap !important;\n  align-items: center;\n  position: relative;\n}\n\n.novisible {\n  display: none !important;\n}\n\n.btn-body {\n  background: #1a1919 0% 0% no-repeat padding-box;\n  border-radius: 9px;\n  opacity: 1;\n  color: white;\n  height: 2rem;\n  width: 2rem;\n  cursor: pointer;\n  border: none;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.btn-body label {\n  cursor: pointer;\n  margin: 0;\n}\n\n.btn-switch-lenguage {\n  padding: 0px !important;\n}\n.btn-switch-lenguage label {\n  font-family: \"Lato\", sans-serif !important;\n}\n\n.morePadding {\n  margin-left: 1rem;\n  top: -0.6rem;\n  right: -2rem;\n}\n\n.navbar-label-rest {\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  padding-right: 4rem;\n  flex-direction: row;\n  cursor: pointer;\n  width: 100%;\n  margin-left: 20px;\n}\n\n.navbar-label-rest-nolocation {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: row;\n  cursor: pointer;\n  width: 20%;\n  margin-left: 10px;\n}\n\n","// Utils\n$DecorationNone: none;\n$Font: \"Lato\", sans-serif !important;\n$Font-size-navbar: 12px;\n$LetterSpacing: 0px;\n\n// Colors\n$Transparent: rgba(0, 0, 0, 0);\n$RedColor: rgb(143, 0, 60, 1);\n$White: rgba(255, 255, 255, 1);\n$Black: rgba(26, 25, 25, 1);\n$MainBackgroundColor: rgba(247, 248, 249, 1);\n$SecondaryBackgroundColor: rgba(221, 208, 208, 0.5);\n$GrayColor: rgba(204, 204, 204, 1);\n$LinkColor: rgba(18, 101, 183, 1);\n$LinkSecondColor: rgba(78, 125, 162, 1);\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
